import { SortingParam } from 'src/common/components/Filters/constants/sorting';
import { ObjectValues } from 'src/common/tsHelpers';

export const PRODUCT_SUMMARY_COLUMN_NAMES_TO_FILTER_MAP = {
  bundleProductCode: 'BundleProductCode',
  activeCount: 'ActiveCount',
  usedData: 'DataUsageAmount',
  sent: 'SmsUsageAmount',
  usedSeconds: 'VoiceUsageAmount',
} as const;

export type ProductSummaryColumnName = keyof typeof PRODUCT_SUMMARY_COLUMN_NAMES_TO_FILTER_MAP;

export type ProductSummarySortField = ObjectValues<
  typeof PRODUCT_SUMMARY_COLUMN_NAMES_TO_FILTER_MAP
>;

export type ProductSummaryApiSorting = SortingParam<ProductSummarySortField>;

export type ProductSumaryInnerColumnSorting = SortingParam<ProductSummaryColumnName>;

export type ProductSummaryEntryDTO = {
  bundleProductCode: string;
  activeCount: number;
  data: {
    used: number;
  };
  sms: {
    sent: number;
  };
  voice: {
    usedSeconds: number;
  };
};

export type ProductSummaryListDTO = {
  totalProducts: number;
  page: number;
  pageSize: number;
  products: ProductSummaryEntryDTO[];
};
